import React, { useMemo } from 'react'
import { ReturnedCurrencyType } from '../../api/shareApi'
import styled from 'styled-components'
import { CatalogPreviewItemType } from '../../api/shareApi'

interface IProductPrice {
    products: CatalogPreviewItemType[]
    product: CatalogPreviewItemType
}
type ASD = Record<string, any>

const ProductPrice = ({ product, products }: IProductPrice): JSX.Element => {
    const calculatePrice: any = useMemo(() => {
        const allCurrency: ASD[] = []
        const finalPrices: ASD = {}

        if (!products) return finalPrices
        if (!product) return finalPrices

        products.forEach(prod => {
            const currency = prod?.price

            if (!currency) {
                return
            }
            // currency.forEach(item => {
            //   const final = {
            //     ...item,
            //     value: Number(item.value)
            //   }
            //   allCurrency.push(final)
            // })
            return currency
        })

        allCurrency.forEach(item => {
            finalPrices[item.code] = item.value
        })

        for (let i = 0; i < allCurrency.length; i++) {
            const fist = allCurrency[i]
            for (let k = i + 1; k < allCurrency.length; k++) {
                const second = allCurrency[k]

                if (fist.code == second.code) {
                    finalPrices[fist.code] = finalPrices[fist.code] + fist.value
                }
            }
        }

        const currency = product?.price

        // currency.forEach(p => {
        //   const f = finalPrices[p.code] ? finalPrices[p.code] : 0
        //   finalPrices[p.code] = f + Number(p.value)
        // })

        return product?.price
    }, [products, product])

    const renderPrice = (price: ASD) => {
        const codes = Object.keys(price)
        return codes.map(code => {
            return (
                <div key={code}>
                    {code} : {price[code]}
                </div>
            )
        })
    }

    return <StyledPriceWrapper>{renderPrice(calculatePrice)}</StyledPriceWrapper>
}

export default ProductPrice

const StyledPriceWrapper = styled.div`
    background-color: rgba(0, 0, 0, 0.1);
    padding: 15px;
    border-radius: 5px;
`
